jQuery(document).ready(function($) {
    var $btns = $('.btn').click(function () { // Filter for listing of employees
        if (this.id == 'all') {
            $('#filter-people > .module-people-person').fadeIn(450);
        } else {
            var $el = $('.' + this.id).fadeIn(450);
            $('#filter-people > .module-people-person').not($el).hide();
        }
        $btns.removeClass('active');
        $(this).addClass('active');
    });
    $(".module-text p > img").parent("p").addClass("inline-img");

        /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/$-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

    var win = $(window);

    var allMods = $(".animate-item");

    allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("already-visible");
        }
    });

    win.scroll(function (event) {

        allMods.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("come-in");
            }
        });

    });

    if ($('#gform_confirmation_message_5').length)
    {
    }

});
jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    jQuery(".gated-hidden").addClass("gated-visible");
    jQuery(".gated-visible-text").removeClass("gated-visible-text").addClass("gated-hidden-text");
});
